import { loader } from 'graphql.macro'

export default function site ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const schema = loader('./site.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { id })
}
